import React, { useState } from "react";
import styled from "styled-components";
import { Header } from "antd/es/layout/layout";
import { Avatar, Badge, Dropdown, Flex, Typography } from "antd";
import { RxHamburgerMenu } from "react-icons/rx";
const { Text } = Typography;
const StyledHeader = styled(Header) `
  background: ${(theme) => (theme.color ? theme.color : "#f5f5f5")};
  border-bottom: ${(theme) => (theme.border ? theme.border : "none")};
  padding: 15px;
  height: 70px;
`;
const HeaderContent = styled(Flex) `
  height: 100%;
`;
const StyledMenu = styled(Flex) `
  gap: 20px;
  height: 47px;
  background: white;
  padding: 12px;
  border-radius: 25px;
  width: 288px;

  @media (max-width: 1200px) {
    width: 260px;
  }
  @media (max-width: 992px) {
    width: 240px;
  }
  @media (max-width: 768px) {
    width: 220px;
    gap: 10px;
  }
  @media (max-width: 576px) {
    width: 200px;
  }
`;
const StyledName = styled(Text) `
  text-transform: capitalize;
  color: rgba(19, 13, 56, 1);
  font-size: 14px;
  font-weight: 500;
  text-align: right;

  @media (max-width: 1200px) {
    font-size: 13px;
  }
  @media (max-width: 992px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    font-size: 11px;
  }
  @media (max-width: 576px) {
    font-size: 10px;
  }
`;
const StyledEmail = styled(Text) `
  color: rgba(19, 13, 56, 1);
  font-size: 12px;
  font-weight: 500;
  text-align: right;

  @media (max-width: 1200px) {
    font-size: 11px;
  }
  @media (max-width: 992px) {
    font-size: 10px;
  }
  @media (max-width: 768px) {
    font-size: 9px;
  }
  @media (max-width: 576px) {
    font-size: 8px;
  }
`;
const StyledAvatar = styled(Avatar) `
  vertical-align: middle;
  color: black;
  font-weight: bold;
  cursor: pointer;
  text-transform: capitalize;
  background: rgba(113, 113, 113, 1);
`;
const StyledLogo = styled.img `
  width: 4vh;
  height: 4vh;
  cursor: pointer;

  @media (max-width: 1200px) {
    width: 3.5vh;
    height: 3.5vh;
  }
  @media (max-width: 992px) {
    width: 3vh;
    height: 3vh;
  }
  @media (max-width: 768px) {
    width: 2.5vh;
    height: 2.5vh;
  }
  @media (max-width: 576px) {
    width: 2vh;
    height: 2vh;
  }
`;
const PageTitle = styled(Text) `
  font-size: 30px;
  line-height: 50px;
  font-weight: 700;
  color: rgb(30, 27, 57);
`;
export const LayoutHeader = ({ name, logout, email, title, color, border, icon, }) => {
    const items = [
        {
            label: "Logout",
            key: "0",
            onClick: () => {
                logout();
            },
        },
    ];
    const [navigationItems, setNavigationItems] = useState(items);
    return (React.createElement(StyledHeader, { color: color, border: border },
        React.createElement(HeaderContent, { align: "center", justify: "space-between" },
            React.createElement(Flex, { align: "center", gap: 10 },
                icon && icon,
                React.createElement(PageTitle, null, title)),
            React.createElement(StyledMenu, { justify: "space-between", align: "center" },
                React.createElement(RxHamburgerMenu, null),
                React.createElement(Flex, { gap: 8 },
                    React.createElement(Flex, { vertical: true },
                        React.createElement(StyledName, null, name),
                        React.createElement(StyledEmail, null, email)),
                    React.createElement(Dropdown, { menu: { items: navigationItems }, trigger: ["click"] },
                        React.createElement(Badge, { dot: true },
                            React.createElement(StyledAvatar, { size: "large" }, name[0]))))))));
};
